"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[833],{

/***/ 40833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_KeepaThemeProvider; }
});

// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(81663);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(92734);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(22040);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@emotion/react/dist/emotion-element-5486c51c.browser.esm.js
var emotion_element_5486c51c_browser_esm = __webpack_require__(76657);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(59436);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/material/CssBaseline/CssBaseline.js
var CssBaseline = __webpack_require__(5404);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(62258);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/material/styles/ThemeProvider.js + 1 modules
var ThemeProvider = __webpack_require__(51166);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/next/dynamic.js
var dynamic = __webpack_require__(60107);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/react/index.js
var react = __webpack_require__(19599);
// EXTERNAL MODULE: ./src/components/common/RTL.jsx
var RTL = __webpack_require__(12682);
// EXTERNAL MODULE: ./src/theme/default.jsx
var theme_default = __webpack_require__(37329);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/x-date-pickers/AdapterDateFnsJalali/AdapterDateFnsJalali.js + 97 modules
var AdapterDateFnsJalali = __webpack_require__(9636);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/x-date-pickers/locales/faIR.js
var faIR = __webpack_require__(9950);
// EXTERNAL MODULE: ../nodevenv/www.keepa.ir/20/lib/node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js
var LocalizationProvider = __webpack_require__(29174);
;// CONCATENATED MODULE: ./src/components/LocaleProvider.jsx





var LocaleProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
        dateAdapter: AdapterDateFnsJalali/* AdapterDateFnsJalali */.Y,
        localeText: faIR/* faIR.components.MuiLocalizationProvider.defaultProps.localeText */.T.components.MuiLocalizationProvider.defaultProps.localeText,
        children: children
    });
};
/* harmony default export */ var components_LocaleProvider = (LocaleProvider);

;// CONCATENATED MODULE: ./src/components/KeepaThemeProvider.jsx











var NextNProgress = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7400).then(__webpack_require__.t.bind(__webpack_require__, 77400, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77400)
            ];
        }
    }
});
var CustomBackdrop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9416), __webpack_require__.e(2217), __webpack_require__.e(3887), __webpack_require__.e(911), __webpack_require__.e(9063)]).then(__webpack_require__.bind(__webpack_require__, 49063));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49063)
            ];
        }
    },
    suspense: true
});
var CustomSnackbar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6701), __webpack_require__.e(8124), __webpack_require__.e(2667)]).then(__webpack_require__.bind(__webpack_require__, 92667));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92667)
            ];
        }
    },
    suspense: true
});
var KeepaThemeProvider = function(param) {
    var children = param.children, emotionCache = param.emotionCache;
    var muiTheme = (0,useTheme/* default */.Z)();
    react.useEffect(function() {
        var jssStyles = document.querySelector("#jss-server-side");
        if (jssStyles) {
            jssStyles.parentElement.removeChild(jssStyles);
        }
    });
    var theme = (0,createTheme/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, muiTheme, theme_default/* themeOptions */.J), {
        direction: "rtl"
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(emotion_element_5486c51c_browser_esm.C, {
        value: emotionCache,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RTL/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
                theme: theme,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextNProgress, {
                        color: "#FFA500"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_LocaleProvider, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline/* default */.ZP, {}),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSnackbar, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBackdrop, {})
                ]
            })
        })
    });
};
/* harmony default export */ var components_KeepaThemeProvider = (KeepaThemeProvider);


/***/ }),

/***/ 12682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19699);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42985);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99147);
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76914);





var ConfigureJSS = function(props) {
    // Configure JSS
    var plugins = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mui_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().plugins);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        jss: (0,jss__WEBPACK_IMPORTED_MODULE_4__/* .create */ .Ue)({
            plugins: plugins
        }),
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfigureJSS);


/***/ })

}]);